@use "../../styles/breakpoint.module.scss" as *;

.root {
    position: relative;
    width: 100%;

    @media ($above-mobile) {
        &:not(.rootIgnoreHoverPause):hover {
            .ticker {
                animation-play-state: paused;
            }
        }
    }
}

.rootPaused {
    .viewport {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .ticker {
        animation: none;

        &[aria-hidden="true"] {
            display: none;
        }
    }
}

.viewport {
    width: 100%;
    overflow-x: hidden;
}

.wrapper {
    display: inline-block;
    white-space: nowrap;
}

.ticker {
    display: inline-block;
    animation: ticker var(--duration) linear infinite;
    width: max-content;
}

.playPauseButton {
    position: absolute;
    top: var(--spacer-12);
    right: var(--spacer-12);
    z-index: 10;
    width: var(--spacer-40);
    height: var(--spacer-40);
    border: 2px solid var(--color-contrast);
    border-radius: var(--border-radius-full);
    color: var(--color-contrast);
    opacity: 0;
    transition: opacity 0.2s;
}

:is(.root:hover, .root:focus-within) .playPauseButton {
    opacity: 1;
}

.playPauseIcon {
    position: absolute;
    inset: 0;
    fill: currentcolor;
}

@keyframes ticker {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}
